import { render, staticRenderFns } from "./qrioshome.vue?vue&type=template&id=099ad246&scoped=true"
import script from "./qrioshome.vue?vue&type=script&lang=js"
export * from "./qrioshome.vue?vue&type=script&lang=js"
import style0 from "./qrioshome.vue?vue&type=style&index=0&id=099ad246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099ad246",
  null
  
)

export default component.exports